"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMLoopCompiler = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../../interfaces/vm-transformers/IVMCompilerUtils");
const IVMScopeManager_1 = require("../../../../interfaces/vm-transformers/IVMScopeManager");
const IVMDestructuringBytecodeCompiler_1 = require("../../../../interfaces/vm-transformers/compilers/IVMDestructuringBytecodeCompiler");
const IVMVariableCollector_1 = require("../../../../interfaces/vm-transformers/analyzers/IVMVariableCollector");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../../node/NodeGuards");
const VMConstants_1 = require("../../../VMConstants");
let VMLoopCompiler = class VMLoopCompiler {
    constructor(vmCompilerUtils, scopeManager, destructuringCompiler, variableCollector) {
        this.vmCompilerUtils = vmCompilerUtils;
        this.scopeManager = scopeManager;
        this.destructuringCompiler = destructuringCompiler;
        this.variableCollector = variableCollector;
    }
    compileWhileStatement(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const loopStart = context.instructions.length;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.test);
        const jumpToEnd = builder.jumpIfFalse();
        const jumpToEndIndex = jumpToEnd.getIndex();
        context.breakTargets.push(jumpToEndIndex);
        this.scopeManager.pushBreakEnvDepth(context);
        context.continueTargets.push(loopStart);
        this.scopeManager.pushContinueEnvDepth(context);
        if (context.currentLabel) {
            context.labelContinueTargets.set(context.currentLabel, loopStart);
            context.currentLabel = null;
        }
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.statement(node.body);
        builder.jump().patchTo(loopStart);
        const endTarget = context.instructions.length;
        jumpToEnd.patchTo(endTarget);
        this.vmCompilerUtils.patchLoopBreakStatements(jumpToEndIndex, endTarget, context);
        context.breakTargets.pop();
        this.scopeManager.popBreakEnvDepth(context);
        context.continueTargets.pop();
        this.scopeManager.popContinueEnvDepth(context);
    }
    compileDoWhileStatement(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const loopStart = context.instructions.length;
        const breakTargetIndex = context.instructions.length;
        context.breakTargets.push(breakTargetIndex);
        this.scopeManager.pushBreakEnvDepth(context);
        const continueTargetSentinel = -(breakTargetIndex + 1);
        context.continueTargets.push(continueTargetSentinel);
        this.scopeManager.pushContinueEnvDepth(context);
        if (context.currentLabel) {
            context.labelContinueTargets.set(context.currentLabel, continueTargetSentinel);
            context.currentLabel = null;
        }
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.statement(node.body);
        const conditionStart = context.instructions.length;
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.test);
        builder.jumpIfTrue().patchTo(loopStart);
        const endTarget = context.instructions.length;
        this.vmCompilerUtils.patchLoopBreakStatements(breakTargetIndex, endTarget, context);
        this.vmCompilerUtils.patchJumpTargets(loopStart, endTarget - 1, continueTargetSentinel, conditionStart, context);
        context.breakTargets.pop();
        this.scopeManager.popBreakEnvDepth(context);
        context.continueTargets.pop();
        this.scopeManager.popContinueEnvDepth(context);
    }
    compileForStatement(node, context) {
        var _a, _b, _c, _d, _e, _f, _g;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        const loopVariables = [];
        let needsPerIterationBinding = false;
        let hasBlockScopedInit = false;
        let hasShadowingLoopVar = false;
        if (node.init && NodeGuards_1.NodeGuards.isVariableDeclarationNode(node.init)) {
            if (node.init.kind === 'let' || node.init.kind === 'const') {
                hasBlockScopedInit = true;
                for (const declaration of node.init.declarations) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(declaration.id)) {
                        const varName = declaration.id.name;
                        const hasFunc = this.vmCompilerUtils.containsFunction(node.body);
                        if (hasFunc) {
                            needsPerIterationBinding = true;
                            loopVariables.push(varName);
                            const shadowsOuterVariable = (_a = (context.parentContext &&
                                this.vmCompilerUtils.isDeclaredInParentScope(varName, context.parentContext))) !== null && _a !== void 0 ? _a : context.envVars.has(varName);
                            if (!shadowsOuterVariable) {
                                context.envVars.add(varName);
                            }
                            else {
                                context.envVars.add(varName);
                                hasShadowingLoopVar = true;
                            }
                            if (!context.perIterationLoopVars) {
                                context.perIterationLoopVars = new Set();
                            }
                            context.perIterationLoopVars.add(varName);
                        }
                    }
                }
            }
        }
        let blockHandle = null;
        if (hasBlockScopedInit) {
            blockHandle = this.scopeManager.enterBlock(context);
        }
        if (hasShadowingLoopVar) {
            builder.getEnv();
            builder.createEnv();
            context.envDepth++;
        }
        if (node.init) {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node.init)) {
                if (hasBlockScopedInit && blockHandle && (node.init.kind === 'let' || node.init.kind === 'const')) {
                    for (const declarator of node.init.declarations) {
                        if (NodeGuards_1.NodeGuards.isIdentifierNode(declarator.id)) {
                            const varName = declarator.id.name;
                            const scopedKey = (0, VMConstants_1.getScopedVariableName)(varName, context.blockScopeDepth);
                            this.scopeManager.trackBlockVariable(blockHandle, scopedKey);
                            (_b = context.activeBlockScopes) === null || _b === void 0 ? void 0 : _b.add(scopedKey);
                        }
                    }
                }
                (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.statement(node.init);
            }
            else {
                (_d = context.dispatch) === null || _d === void 0 ? void 0 : _d.expression(node.init);
                builder.pop();
            }
        }
        const loopStart = context.instructions.length;
        let breakSentinel = null;
        if (node.test) {
            (_e = context.dispatch) === null || _e === void 0 ? void 0 : _e.expression(node.test);
            const jumpToEnd = builder.jumpIfFalse();
            const jumpToEndIndex = jumpToEnd.getIndex();
            jumpToEnd.patchTo(0);
            context.breakTargets.push(jumpToEndIndex);
            this.scopeManager.pushBreakEnvDepth(context);
            breakSentinel = jumpToEndIndex;
        }
        else {
            breakSentinel = loopStart;
            context.breakTargets.push(breakSentinel);
            this.scopeManager.pushBreakEnvDepth(context);
        }
        if (needsPerIterationBinding) {
            builder.getEnv();
            builder.createEnv();
            context.envDepth++;
            for (const varName of loopVariables) {
                builder.loadFromEnvByName(varName);
                builder.storeToCurrentEnvByName(varName);
            }
        }
        const continueSentinel = context.instructions.length;
        context.continueTargets.push(continueSentinel);
        this.scopeManager.pushContinueEnvDepth(context);
        if (context.currentLabel) {
            context.labelContinueTargets.set(context.currentLabel, continueSentinel);
            context.currentLabel = null;
        }
        (_f = context.dispatch) === null || _f === void 0 ? void 0 : _f.statement(node.body);
        if (needsPerIterationBinding) {
            builder.restoreParentEnv();
            context.envDepth--;
        }
        const actualContinueTarget = context.instructions.length;
        if (node.update) {
            (_g = context.dispatch) === null || _g === void 0 ? void 0 : _g.expression(node.update);
            builder.pop();
        }
        builder.jump().patchTo(loopStart);
        const endTarget = context.instructions.length;
        this.patchForLoopTargets(breakSentinel, continueSentinel, actualContinueTarget, endTarget, context);
        context.continueTargets.pop();
        this.scopeManager.popContinueEnvDepth(context);
        if (hasShadowingLoopVar) {
            builder.restoreParentEnv();
            context.envDepth--;
        }
        if (blockHandle) {
            this.scopeManager.exitBlockWithHandle(context, blockHandle);
        }
    }
    compileForOfStatement(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.right);
        builder.getIterator();
        const { actualIndex: actualIteratorIndex } = this.vmCompilerUtils.createTempLocal(`__forof_iterator_${context.localVariables.size}`, context);
        builder.storeLocal(actualIteratorIndex);
        builder.pop();
        const analysis = this.analyzeIterableLoopVariable(node, context);
        const loopStart = context.instructions.length;
        builder.loadLocal(actualIteratorIndex);
        builder.iteratorNext();
        builder.dup();
        builder.iteratorDone();
        const jumpToEnd = builder.jumpIfTrue();
        const jumpToEndIndex = jumpToEnd.getIndex();
        const continueTargetSentinel = context.instructions.length;
        this.pushLoopTargets(jumpToEndIndex, continueTargetSentinel, context);
        if (analysis.needsNewEnv) {
            this.enterIterationEnv(builder, context);
        }
        builder.getProp('value');
        if (!this.storeSimpleLoopVariable(analysis, builder, context)) {
            if (analysis.loopDestructuringPattern) {
                this.handleDestructuringLoopVariable(analysis, context);
            }
            else {
                builder.pop();
            }
        }
        const shouldAddToEnvVars = this.setupLoopVarEnvTracking(analysis, context);
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.statement(node.body);
        this.cleanupLoopVarEnvTracking(analysis, shouldAddToEnvVars, context);
        if (analysis.needsNewEnv) {
            this.exitIterationEnv(builder, context);
        }
        const actualContinueTarget = context.instructions.length;
        builder.jump().patchTo(loopStart);
        const normalExitTarget = context.instructions.length;
        builder.pop();
        const breakExitTarget = context.instructions.length;
        jumpToEnd.patchTo(normalExitTarget);
        this.vmCompilerUtils.patchJumpTargets(continueTargetSentinel, normalExitTarget - 1, continueTargetSentinel, actualContinueTarget, context);
        this.vmCompilerUtils.patchJumpTargets(continueTargetSentinel, normalExitTarget - 1, jumpToEndIndex, breakExitTarget, context);
        this.popLoopTargets(context);
    }
    compileForInStatement(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.right);
        builder.emitStaticMethodCall('Object', 'keys', 1);
        const { actualIndex: actualKeysIndex } = this.vmCompilerUtils.createTempLocal(`__forin_keys_${context.localVariables.size}`, context);
        builder.storeLocal(actualKeysIndex);
        builder.pop();
        const { actualIndex: actualCounterIndex } = this.vmCompilerUtils.createTempLocal(`__forin_counter_${context.localVariables.size}`, context);
        builder.loadConst(0);
        builder.storeLocal(actualCounterIndex);
        builder.pop();
        const analysis = this.analyzeIterableLoopVariable(node, context);
        const loopStart = context.instructions.length;
        builder.loadLocal(actualCounterIndex);
        builder.loadLocal(actualKeysIndex);
        builder.getProp('length');
        builder.lessThan();
        const jumpToEnd = builder.jumpIfFalse();
        const jumpToEndIndex = jumpToEnd.getIndex();
        const continueTargetSentinel = context.instructions.length;
        this.pushLoopTargets(jumpToEndIndex, continueTargetSentinel, context);
        if (analysis.needsNewEnv) {
            this.enterIterationEnv(builder, context);
        }
        builder.loadLocal(actualKeysIndex);
        builder.loadLocal(actualCounterIndex);
        builder.getComputed();
        if (!this.storeSimpleLoopVariable(analysis, builder, context)) {
            if (analysis.loopDestructuringPattern) {
                this.handleDestructuringLoopVariable(analysis, context);
            }
            else {
                builder.pop();
            }
        }
        const shouldAddToEnvVars = this.setupLoopVarEnvTracking(analysis, context);
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.statement(node.body);
        this.cleanupLoopVarEnvTracking(analysis, shouldAddToEnvVars, context);
        if (analysis.needsNewEnv) {
            this.exitIterationEnv(builder, context);
        }
        const actualContinueTarget = context.instructions.length;
        this.emitCounterIncrement(actualCounterIndex, builder);
        builder.jump().patchTo(loopStart);
        const endTarget = context.instructions.length;
        jumpToEnd.patchToHere();
        this.vmCompilerUtils.patchJumpTargets(continueTargetSentinel, endTarget - 1, continueTargetSentinel, actualContinueTarget, context);
        this.popLoopTargets(context);
    }
    patchForLoopTargets(breakSentinel, continueSentinel, actualContinueTarget, endTarget, context) {
        if (breakSentinel !== null && context.breakTargets.length > 0) {
            const poppedBreakSentinel = context.breakTargets.pop();
            this.scopeManager.popBreakEnvDepth(context);
            if (poppedBreakSentinel !== undefined) {
                context.instructions[poppedBreakSentinel].target = endTarget;
                this.vmCompilerUtils.patchJumpTargets(poppedBreakSentinel, endTarget - 1, poppedBreakSentinel, endTarget, context);
            }
        }
        this.vmCompilerUtils.patchJumpTargets(continueSentinel, endTarget - 1, continueSentinel, actualContinueTarget, context);
    }
    pushLoopTargets(breakIndex, continueIndex, context) {
        context.breakTargets.push(breakIndex);
        this.scopeManager.pushBreakEnvDepth(context);
        context.continueTargets.push(continueIndex);
        this.scopeManager.pushContinueEnvDepth(context);
        if (context.currentLabel) {
            context.labelContinueTargets.set(context.currentLabel, continueIndex);
            context.currentLabel = null;
        }
    }
    popLoopTargets(context) {
        context.breakTargets.pop();
        this.scopeManager.popBreakEnvDepth(context);
        context.continueTargets.pop();
        this.scopeManager.popContinueEnvDepth(context);
    }
    enterIterationEnv(builder, context) {
        builder.getEnv();
        builder.createEnv();
        context.envDepth++;
    }
    exitIterationEnv(builder, context) {
        builder.restoreParentEnv();
        context.envDepth--;
    }
    emitCounterIncrement(actualCounterIndex, builder) {
        builder.loadLocal(actualCounterIndex);
        builder.loadConst(1);
        builder.add();
        builder.storeLocal(actualCounterIndex);
        builder.pop();
    }
    analyzeIterableLoopVariable(node, context) {
        let loopVarName = null;
        let loopVarLocalIndex = null;
        let loopDestructuringPattern = null;
        let hasBlockScopedLoopVar = false;
        let needsNewEnv = false;
        let declarationKind = 'var';
        if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(node.left)) {
            hasBlockScopedLoopVar = node.left.kind === 'let' || node.left.kind === 'const';
            declarationKind = node.left.kind;
            const declarator = node.left.declarations[0];
            if (declarator) {
                if (NodeGuards_1.NodeGuards.isIdentifierNode(declarator.id)) {
                    loopVarName = declarator.id.name;
                    const shadowingResult = this.scopeManager.checkShadowing(context, loopVarName, {
                        variableKind: 'loop',
                        hasBlockScopedDecl: hasBlockScopedLoopVar
                    });
                    if (shadowingResult.shadows) {
                        needsNewEnv = true;
                    }
                    else {
                        if (context.localVariables.has(loopVarName)) {
                            loopVarLocalIndex = context.localVariables.get(loopVarName);
                        }
                        else {
                            loopVarLocalIndex = context.localVariables.size;
                            context.localVariables.set(loopVarName, loopVarLocalIndex);
                        }
                    }
                }
                else if (NodeGuards_1.NodeGuards.isArrayPatternNode(declarator.id) ||
                    NodeGuards_1.NodeGuards.isObjectPatternNode(declarator.id)) {
                    loopDestructuringPattern = declarator.id;
                    if (hasBlockScopedLoopVar) {
                        const destructuredNames = new Set();
                        this.variableCollector.collectFromPattern(declarator.id, destructuredNames);
                        for (const varName of destructuredNames) {
                            const destructShadowResult = this.scopeManager.checkShadowing(context, varName, {
                                variableKind: 'loop',
                                hasBlockScopedDecl: true
                            });
                            if (destructShadowResult.shadows) {
                                needsNewEnv = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
        return {
            loopVarName,
            loopVarLocalIndex,
            loopDestructuringPattern,
            hasBlockScopedLoopVar,
            needsNewEnv,
            declarationKind
        };
    }
    storeSimpleLoopVariable(analysis, builder, context) {
        if (!analysis.loopVarName) {
            return false;
        }
        if (analysis.needsNewEnv) {
            const nameIndex = context.constantPool.add(analysis.loopVarName);
            if (analysis.declarationKind === 'const') {
                builder.storeToCurrentEnvConst(nameIndex);
            }
            else {
                builder.storeToCurrentEnv(nameIndex);
            }
            return true;
        }
        else if (analysis.loopVarLocalIndex !== null) {
            const actualLoopVarIndex = this.vmCompilerUtils.getActualLocalIndex(analysis.loopVarLocalIndex, context);
            builder.storeLocal(actualLoopVarIndex);
            builder.pop();
            return true;
        }
        return false;
    }
    handleDestructuringLoopVariable(analysis, context) {
        if (!analysis.loopDestructuringPattern) {
            return;
        }
        if (analysis.needsNewEnv && analysis.hasBlockScopedLoopVar) {
            const patternNamesSet = new Set();
            this.variableCollector.collectFromPattern(analysis.loopDestructuringPattern, patternNamesSet);
            const patternNames = Array.from(patternNamesSet);
            const addedToEnvVars = [];
            for (const name of patternNames) {
                if (!context.envVars.has(name)) {
                    context.envVars.add(name);
                    addedToEnvVars.push(name);
                }
            }
            if (!context.perIterationLoopVars) {
                context.perIterationLoopVars = new Set();
            }
            for (const name of patternNames) {
                context.perIterationLoopVars.add(name);
            }
            const removedFromActiveBlockScopes = [];
            if (context.activeBlockScopes) {
                for (const name of patternNames) {
                    for (let depth = context.blockScopeDepth; depth >= 0; depth--) {
                        const scopedKey = (0, VMConstants_1.getScopedVariableName)(name, depth);
                        if (context.activeBlockScopes.has(scopedKey)) {
                            context.activeBlockScopes.delete(scopedKey);
                            removedFromActiveBlockScopes.push(scopedKey);
                        }
                    }
                }
            }
            if (context._removedFromActiveBlockScopes !== undefined) {
                context._previousRemovedFromActiveBlockScopes = context._removedFromActiveBlockScopes;
            }
            context._removedFromActiveBlockScopes = removedFromActiveBlockScopes;
            const previousDeclarationKind = context._declarationKind;
            context._declarationKind = analysis.declarationKind;
            const localVarsBefore = new Set(context.localVariables.keys());
            this.destructuringCompiler.compileDestructuringPattern(analysis.loopDestructuringPattern, context, true);
            context._declarationKind = previousDeclarationKind;
            const keysToRemove = [];
            for (const key of context.localVariables.keys()) {
                if (!localVarsBefore.has(key) && patternNames.includes(key)) {
                    keysToRemove.push(key);
                }
            }
            for (const key of keysToRemove) {
                context.localVariables.delete(key);
            }
            if (context._loopDestructuredVarsToCleanup !== undefined) {
                context._previousLoopDestructuredVarsToCleanup = context._loopDestructuredVarsToCleanup;
            }
            context._loopDestructuredVarsToCleanup = addedToEnvVars;
        }
        else {
            const previousDeclarationKind = context._declarationKind;
            context._declarationKind = analysis.declarationKind;
            this.destructuringCompiler.compileDestructuringPattern(analysis.loopDestructuringPattern, context, true);
            context._declarationKind = previousDeclarationKind;
        }
    }
    setupLoopVarEnvTracking(analysis, context) {
        const shadowsOuterEnvVar = analysis.loopVarName && context.envVars.has(analysis.loopVarName);
        const shouldAddToEnvVars = !!(analysis.needsNewEnv && analysis.loopVarName && !shadowsOuterEnvVar);
        if (shouldAddToEnvVars && analysis.loopVarName) {
            context.envVars.add(analysis.loopVarName);
            if (!context.perIterationLoopVars) {
                context.perIterationLoopVars = new Set();
            }
            context.perIterationLoopVars.add(analysis.loopVarName);
        }
        if (analysis.needsNewEnv &&
            analysis.loopVarName &&
            analysis.hasBlockScopedLoopVar &&
            context.activeBlockScopes) {
            const removedFromActiveBlockScopes = [];
            for (let depth = context.blockScopeDepth; depth >= 0; depth--) {
                const scopedKey = (0, VMConstants_1.getScopedVariableName)(analysis.loopVarName, depth);
                if (context.activeBlockScopes.has(scopedKey)) {
                    context.activeBlockScopes.delete(scopedKey);
                    removedFromActiveBlockScopes.push(scopedKey);
                }
            }
            if (removedFromActiveBlockScopes.length > 0) {
                if (context._removedFromActiveBlockScopes !== undefined) {
                    context._previousRemovedFromActiveBlockScopes = context._removedFromActiveBlockScopes;
                }
                context._removedFromActiveBlockScopes = removedFromActiveBlockScopes;
            }
        }
        return shouldAddToEnvVars;
    }
    cleanupLoopVarEnvTracking(analysis, shouldAddToEnvVars, context) {
        var _a, _b;
        if (shouldAddToEnvVars && analysis.loopVarName) {
            context.envVars.delete(analysis.loopVarName);
            (_a = context.perIterationLoopVars) === null || _a === void 0 ? void 0 : _a.delete(analysis.loopVarName);
        }
        const destructuredVarsToCleanup = context._loopDestructuredVarsToCleanup;
        const previousLoopDestructuredVarsToCleanup = context._previousLoopDestructuredVarsToCleanup;
        if (destructuredVarsToCleanup) {
            for (const name of destructuredVarsToCleanup) {
                context.envVars.delete(name);
                (_b = context.perIterationLoopVars) === null || _b === void 0 ? void 0 : _b.delete(name);
            }
            if (previousLoopDestructuredVarsToCleanup !== undefined) {
                context._loopDestructuredVarsToCleanup = previousLoopDestructuredVarsToCleanup;
                delete context._previousLoopDestructuredVarsToCleanup;
            }
            else {
                delete context._loopDestructuredVarsToCleanup;
            }
        }
        const removedFromActiveBlockScopes = context._removedFromActiveBlockScopes;
        const previousRemovedFromActiveBlockScopes = context._previousRemovedFromActiveBlockScopes;
        if (removedFromActiveBlockScopes && context.activeBlockScopes) {
            for (const scopedKey of removedFromActiveBlockScopes) {
                context.activeBlockScopes.add(scopedKey);
            }
            if (previousRemovedFromActiveBlockScopes !== undefined) {
                context._removedFromActiveBlockScopes = previousRemovedFromActiveBlockScopes;
                delete context._previousRemovedFromActiveBlockScopes;
            }
            else {
                delete context._removedFromActiveBlockScopes;
            }
        }
    }
};
exports.VMLoopCompiler = VMLoopCompiler;
exports.VMLoopCompiler = VMLoopCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMScopeManager)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMDestructuringBytecodeCompiler)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableCollector)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object, typeof (_b = typeof IVMScopeManager_1.IVMScopeManager !== "undefined" && IVMScopeManager_1.IVMScopeManager) === "function" ? _b : Object, typeof (_c = typeof IVMDestructuringBytecodeCompiler_1.IVMDestructuringBytecodeCompiler !== "undefined" && IVMDestructuringBytecodeCompiler_1.IVMDestructuringBytecodeCompiler) === "function" ? _c : Object, typeof (_d = typeof IVMVariableCollector_1.IVMVariableCollector !== "undefined" && IVMVariableCollector_1.IVMVariableCollector) === "function" ? _d : Object])
], VMLoopCompiler);
